import {AfterContentInit, Component, EventEmitter, inject, Output, signal, ViewChild} from '@angular/core';
import {connectSearchBox} from 'instantsearch.js/es/connectors';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {AlgoliaHitsComponent} from '../algolia-hits/algolia-hits.component';
import {MatButton} from '@angular/material/button';
import {CustomerInfoFormModalComponent} from '../customer-info-form-modal/customer-info-form-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {AlgoliaService} from '../../core/services/algolia.service';

@Component({
  selector: 'app-algolia-search-box',
  standalone: true,
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    AlgoliaHitsComponent,
    MatButton,
    MatIconModule,
    MatFormFieldModule
  ],
  templateUrl: './algolia-search-box.component.html',
  styleUrl: './algolia-search-box.component.scss'
})
export class AlgoliaSearchBoxComponent implements AfterContentInit {
  private algoliaService = inject(AlgoliaService);

  readonly dialog = inject(MatDialog);

  public refine: ((query: string) => void) | undefined;
  public query = signal('');

  constructor() {
    this.algoliaService.addWidgets([
      connectSearchBox(({ refine, query }) => {
        this.refine = refine;
        this.query.set(query);
      })({
      }),
    ]);
  }

  ngAfterContentInit() {
    this.algoliaService.start();
  }

  public search(value: string) {
    this.refine!(value);
  }

  createCustomer() {
    this.dialog.open(CustomerInfoFormModalComponent, {
      width: '900px',
      maxWidth: '90vw',
      data: {
        phoneNumber: this.query(),
        isCreateCustomer: true
      }
    });
    this.resetSearch();
  }

  resetSearch() {
    this.query.set('');
    this.refine!('');
  }
}
